import { useEffect, useState } from 'react';
export var useDebouncedState = function (value, delay) {
    if (delay === void 0) { delay = 500; }
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () { return clearTimeout(handler); };
    }, [value, delay]);
    return debouncedValue;
};
